import { Flex, Icon, Input, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { INVOICE_CLIENT_REFERENCE_CHARACTER_LIMIT } from '../../../../../../../../constants/invoiceClientReferenceCharacterLimit'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'

export const InvoicePurchaseOrderNumber = (): ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()

  const { FormItem } = invoiceEditorForm

  const handleDebouncedInputChange = useDebouncedCallback((value: string) =>
    trackInvoiceEditor('Form - Invoice Purchase Order Number typed', {
      referenceLength: value.length,
    }),
  )

  const label = (
    <Flex as="span" flexDirection="row" gap={Spacing.S4}>
      <Text colorVariant="secondary">{t('external_invoices.editor.form.field.invoice_purchase_order.label')}</Text>
      <Tooltip label={t('external_invoices.editor.form.field.invoice_purchase_order.tooltip.label')} placement="top">
        <Icon icon="info" size="xs" />
      </Tooltip>
    </Flex>
  )

  return (
    <FormItem
      name="purchaseOrderNumber"
      label={label}
      render={({ field: { onChange, ...props } }) => {
        return (
          <Input
            {...props}
            maxLength={INVOICE_CLIENT_REFERENCE_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedInputChange(event.target.value)
            }}
            size="sm"
            placeholder={t('external_invoices.editor.form.field.invoice_purchase_order.placeholder.label')}
          />
        )
      }}
    />
  )
}
